'use client';
import { handlePropVehicleAnalytics } from '@/helpers/adobe';
import { TYPE_CAR, VEHICLE_TYPE } from '@/helpers/constants';
import { useGeneralStore } from '@/providers/general-store-provider';
import { memo, useEffect } from 'react';

type VehicleAnalytics = { brand?: string; model?: string; year?: string };

const VehicleAnalytics = ({ brand, model, year }: VehicleAnalytics) => {
    const { vehicleType } = useGeneralStore();

    const getVehicleAnalytics = () => {
        handlePropVehicleAnalytics(vehicleType === TYPE_CAR ? VEHICLE_TYPE.CAR : VEHICLE_TYPE.BIKE, brand, model, year);
    };

    useEffect(() => {
        getVehicleAnalytics();
    }, []);

    return <></>;
};

export default VehicleAnalytics;
